import axios from '../../axios-marketplace';

const updateComissao = (idCompra, idComissao, data) => axios.put(`/compras/${idCompra}/comissao/${idComissao}`, data);
const getComissaoCompra = (idCompra) => axios.get(`/compras/${idCompra}/comissao`);

export default {
  updateComissao,
  getComissaoCompra,
};
